<template>

  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <!-- Table Container Card -->
      <b-card
        no-body
        class="mb-0"
      >

        <div class="m-2">

          <!-- Table Top -->
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Show</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>entries</label>
            </b-col>

            <!-- Search -->
            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Search..."
                />
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="fetchTranslations"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
        >

          <!-- Column: Id -->
          <template #cell(id)="data">
            <span class="align-text-top text-capitalize">{{ data.item.id }}</span>
          </template>

          <!-- Column: Title -->
          <template #cell(title)="data">
            <div class="text-nowrap">
              <span class="align-text-top text-capitalize">{{ data.item.title }}</span>
            </div>
          </template>

          <!-- Column: Key -->
          <template #cell(key)="data">
            {{ data.item.key }}
          </template>

          <template #cell(translation)="data">
            {{ data.item.translation }}
          </template>

          <!-- Column: Actions -->
          <template
            #cell(actions)="data"
          >
            <feather-icon
              v-if="$ability.can(constants.action.permissionTranslationEdit, constants.resource.translation) || $ability.can(constants.action.permissionTranslationAdd, constants.resource.translation)"
              v-b-modal.modal-translation
              icon="EditIcon"
              @click="getTranslation(data.item.id)"
            />
          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalUsers"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>

        <b-modal
          v-show="!modalLoader"
          id="modal-translation"
          cancel-variant="outline-secondary"
          ok-title="Update"
          cancel-title="Close"
          centered
          title="Update Translation"
          @ok="handleSubmit"
          @hidden="resetModal"
        >
          <b-overlay
            id="overlay-background"
            :show="modalLoader === true"
            variant="dark"
            opacity="0.85"
            blur="2px"
            rounded="sm"
            spinner-variant="primary"
            spinner-medium
          >
            <b-form>
              <b-form-group>
                <label for="translationKey">Key</label>
                <b-form-input
                  id="translationKey"
                  v-model="translationKey"
                  type="text"
                  placeholder="Key"
                  disabled
                />
              </b-form-group>
              <b-form-group
                v-for="(row, index) in translationValues"
                :key="index"
              >
                <label for="translation">{{ row[0] }}</label>
                <b-form-input
                  v-model="translationValues[index][1]"
                  type="text"
                  placeholder="Translation"
                />
              </b-form-group>
            </b-form>
          </b-overlay>
        </b-modal>

      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BPagination, BOverlay, BModal,
  BForm, BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import constants from '@/app-configs/constants'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useTranslationList from './useTranslationList'
import translationsStoreModule from '../translationsStoreModule'

export default {
  components: {
    // UsersListFilters,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BPagination,

    vSelect,
    BOverlay,
    BModal,
    BForm,
    BFormGroup,
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'translations'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, translationsStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const {
      fetchTranslations,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      loader,
    } = useTranslationList()

    return {

      // Sidebar

      fetchTranslations,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      loader,
      constants,
    }
  },
  data() {
    return {
      modalLoader: false,
      translationKey: '',
      translationValue: '',
      translationValues: [],
    }
  },
  created() {
    this.actionColumn()
  },
  methods: {
    async getTranslation(id) {
      this.modalLoader = true
      this.translationValues = []
      await axios.get(`/translations/get-details?id=${id}`)
        .then(response => {
          this.translationKey = response.data.data.key
          const tValues = response.data.data.values
          Object.keys(tValues).forEach(element => {
            this.translationValues.push([element, response.data.data.values[element].value, response.data.data.values[element].valueId])
          })
          this.modalLoader = false
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              icon: 'CoffeeIcon',
              variant: 'danger',
              text: error,
            },
          })
        })
    },
    async handleSubmit() {
      // this.modalLoader = true
      const postArgs = []
      postArgs.translations = this.translationValues
      // console.log('==>', postArgs)
      await axios
        .post('/translations/edit', { ...postArgs })
        .then(response => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: response.data.message.title,
              icon: 'CoffeeIcon',
              variant: 'success',
              text: response.data.message.text,
            },
          })
        }).catch(error => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              icon: 'CoffeeIcon',
              variant: 'danger',
              text: error.response.data.message,
            },
          })
        })
    },
    resetModal() {
      this.loader = false
    },
    actionColumn() {
      if (this.$ability.cannot(constants.action.permissionTranslationEdit, constants.resource.translation) && this.$ability.cannot(constants.action.permissionTranslationAdd, constants.resource.translation)) {
        this.tableColumns.splice(3)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
